import { useSelector } from 'react-redux';
import { EnergyState } from 'store/slices/EnergySlice/types';
import { selectIsRecomputing } from 'store/slices/DsmShadingSlice/selectors';
import { PanelTitle } from '../style';
import UpdatingEstimate from './UpdatingEstimate';

interface Props {
	energy: EnergyState;
}

export default function Production({ energy }: Props) {
	const isShadingAnalysisLoading = useSelector(selectIsRecomputing);
	return <PanelTitle className="production-title">
		<h4>Production kWh</h4>
		{isShadingAnalysisLoading
			? <UpdatingEstimate />
			: <h2>{energy.deratedEnergy.toFixed(2)} </h2>
		}
	</PanelTitle>;
}
